module.exports = __webpack_public_path__ + "8f9ba8bb32daae845c809f6a1c61f66f.png";